<template>
  <b-modal
    id="new-filter-modal"
    :title="title"
    centered
    hide-footer
    :no-close-on-backdrop="true"
    @hidden="resetModal"
  >
    <b-form @submit.prevent="submit">
      <b-form-group label="Name" label-for="name">
        <b-form-input
          id="name"
          v-model="fields.name"
          v-validate="{ required: true }"
          type="text"
          placeholder="Name"
          data-vv-name="Name"
          size="lg"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Category" label-for="category">
        <multiselect
          v-model="fields.category"
          v-validate="{ required: true }"
          :options="validFilters"
          :taggable="true"
          label="name"
          placeholder="Select category"
          tag-placeholder="Create new category"
          open-direction="bottom"
          data-vv-name="category"
          @input="categoryChanged"
          @tag="createCategory"
        ></multiselect>
      </b-form-group>

      <b-form-group label="Subcategory" label-for="subcategory">
        <multiselect
          v-model="fields.subcategory"
          v-validate="{ required: true }"
          :options="selectedCategoryFilters"
          :taggable="true"
          label="name"
          placeholder="Select subcategory"
          tag-placeholder="Create new subcategory"
          open-direction="bottom"
          data-vv-name="subcategory"
          @tag="createSubCategory"
        ></multiselect>
      </b-form-group>

      <b-form-checkbox v-model="fields.visibility.discover" size="sm" class="mb-4" switch
        >Discover Visibility</b-form-checkbox
      >

      <b-row>
        <b-col class="text-right">
          <b-btn variant="primary" type="submit">Save</b-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import _ from "lodash";
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";
import DataSettings from "@/helpers/DataSettings";

export default {
  name: "NewFilterModal",
  components: {
    Multiselect
  },
  props: {
    title: {
      type: String,
      required: true
    },
    filter: {
      type: [String, Object, Array], // TODO: Check allowed types
      required: false,
      default: null
    }
  },
  data() {
    return {
      fields: {
        name: null,
        category: null,
        subcategory: null,
        visibility: {
          'all': true,
          'discover': true
        }
      }
    };
  },
  computed: {
    ...mapState({
      filters: state => state.filter.filters
    }),
    validFilters(){
      return this.filters.filter(c => c.name !== 'tempmaincat' && !c.name.includes("_del"));
    },
    selectedCategoryFilters() {
      if (
        !this.filters ||
        !this.fields.category ||
        !this.fields.category.children
      ) {
        return [];
      }

      return this.fields.category.children.filter(c => !c.name.includes("_del"));
    }
  },
  watch: {
    filter(val) {
      this.fields.name = val.name;
      this.fields.category = val.category;
      this.fields.subcategory = val.subcategory;
      _.each(this.filters, cat => {
        _.each(cat.children, subcat => {
          let contains = _.findIndex(subcat.children, f => f._id === val._id);
          if (contains > -1) {
            this.fields.category = cat;
            this.fields.subcategory = subcat;
          }
        });
      });
    }
  },
  methods: {
    ...mapActions(["saveFilter"]),
    categoryChanged() {
      if (
        !this.fields.category ||
        !this.fields.subcategory ||
        !this.fields.subcategory.parent_id
      ) {
        this.fields.subcategory = null;
        return;
      }

      if (this.fields.category._id !== this.fields.subcategory.parent_id) {
        this.fields.subcategory = null;
      }
    },
    createCategory(e) {
      this.fields.category = { name: e };
    },
    createSubCategory(e) {
      this.fields.subcategory = { name: e };
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return false;
        }

        let payloadFilter;
        if (this.filter) {
          payloadFilter = {
            name: this.fields.name,
            type: "filter",
            query: Array.isArray(this.filter) ? this.filter : [this.filter]
          };
        }

        let samecat = _.findIndex(this.filters, f => f.name === (this.filter.category? this.filter.category.name:'not-found'));
        if (samecat > -1) {
          this.fields.category = this.filters[samecat];
          let samesubcat = _.findIndex(this.filters[samecat].children, f => f.name === this.filter.subcategory.name);
          if (samesubcat > -1) {
            this.fields.subcategory = this.filters[samecat].children[samesubcat];
            let samefilter = _.findIndex(this.filters[samecat].children[samesubcat].children, f => f.name === this.filter.name);
            if(samefilter > -1){
              this.$toasted.show("Filter already exists with same name, category and subcategory", {
                type: "error"
              });
              return false;
            }
          }
        }

        let payloadCategory = {};
        if (this.fields.category._id) {
          payloadCategory._id = this.fields.category._id;
        } else {
          payloadCategory.name = this.fields.category.name;
        }

        let payloadSubcategory = {};
        if (this.fields.subcategory._id) {
          payloadSubcategory._id = this.fields.subcategory._id;
        } else {
          payloadSubcategory.name = this.fields.subcategory.name;
        }
        this.saveFilter({
          filter: payloadFilter,
          category: payloadCategory,
          subcategory: payloadSubcategory
        }).then((added) => {
          this.updateVisibility(added);
          /*
          this.updateVisibility({
            filter: added,
            category: payloadCategory,
            subcategory: payloadSubcategory
          })
          */
          this.$emit("clearBuilder");
          this.$bvModal.hide("new-filter-modal");
          this.$toasted.show("Filter updated");
        });
      });
    },
    updateVisibility(data){
      const settings = DataSettings.getSettings("focus");
      if(!this.fields.visibility.discover){
        if(!settings.lastQuery.includes(data._id)){
          let newSettings = settings.lastQuery;
          newSettings.push(data._id);
          DataSettings.setSettings("focus.lastQuery", newSettings);
        }
      }
      else{
        if(settings.lastQuery.includes(data._id)){
          let newSettings = settings.lastQuery;
          const index = _.findIndex(newSettings, data._id);
          newSettings.splice(index, 1);
          DataSettings.setSettings("focus.lastQuery", newSettings);
        }
      }
    /*
      const filter = data.filter;
      const category = data.category;
      const subcategory = data.subcategory;
      const settings = DataSettings.getSettings("focus");
      let discoverCats = settings.lastQuery;
      let cindex = _.findIndex(discoverCats, (f) => { return f._id === category._id; });
      let sindex = _.findIndex(discoverCats[cindex].children, (f) => { return f._id === subcategory._id; });
      let newSettings = discoverCats;
      newSettings[cindex].children[sindex].children.push(filter);
      let index = _.findIndex(newSettings[cindex].children[sindex].children, (f) => { return f._id === filter._id; });
      newSettings[cindex].children[sindex].children[index].visibility = this.fields.visibility;
      DataSettings.setSettings("focus.lastQuery", newSettings);
    */
    },
    resetModal() {
      this.$emit("clearBuilder");
      this.fields = {
        name: null,
        category: null,
        subcategory: null,
        visibility: {
          'all': true,
          'discover': false
        }
      };
    }
  }
};
</script>
